import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { PutAdminV1OrgProductsIdMediaBody } from '@nucleus-commerce/api-client/admin';

import { productsApi } from '../api/products-api';

import { productKeys } from './product-keys';

export function productMediaQueryOptions(productId: string) {
  return queryOptions({
    queryKey: productKeys.media(productId),
    queryFn: () => productsApi.getMedia(productId),
  });
}

export function useProductMedia(productId: string) {
  return useQuery(productMediaQueryOptions(productId));
}

/**
 * PUT replaces the whole ordered list; the product's `featuredMediaId` changes with it. Saves of
 * one product's gallery run one at a time, so quick successive drags land in the order made.
 */
export function useSetProductMedia(productId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    scope: { id: `product-media:${productId}` },
    mutationFn: (body: PutAdminV1OrgProductsIdMediaBody) => productsApi.setMedia(productId, body),
    onSuccess: (items) => {
      queryClient.setQueryData(productKeys.media(productId), items);
      return Promise.all([
        queryClient.invalidateQueries({ queryKey: productKeys.detail(productId), exact: true }),
        queryClient.invalidateQueries({ queryKey: productKeys.lists() }),
      ]);
    },
  });
}
